import type { Move } from '../../../schemas/move';

/**
 * Archetipi del Druido (manuale V1, rr. 3037-3045).
 *
 * 5 mosse di tipo `class_special`. Pattern razza-tematico standard.
 * Nessuna mossa di archetipo richiede `choices` strutturate (a differenza
 * dell'archetipo Umano del Mago/Chierico).
 *
 * Tutti gli archetipi del Druido sono effetti continuativi o trigger su
 * mosse esistenti del Druido (*Mutaforma*, *Lingua degli Spiriti*,
 * *Fratello del Cacciatore*).
 */

const archetipoUmano: Move = {
  id: 'druido.archetipo-umano',
  name: 'Archetipo: Umano',
  type: 'class_special',
  classId: 'druido',
  trigger: 'Quando applichi *Mutaforma* o *Lingua degli Spiriti* a un animale domestico',
  description:
    "Anche se l'animale non proviene dalla tua Terra, o non ne hai *Studiato l'Essenza*, puoi comunque applicare *Mutaforma* e *Lingua degli Spiriti* a qualsiasi animale domestico.",
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoElfo: Move = {
  id: 'druido.archetipo-elfo',
  name: 'Archetipo: Elfo',
  type: 'class_special',
  classId: 'druido',
  trigger: "Alla creazione del personaggio (alla scelta dell'archetipo)",
  description:
    'Considera sempre le Grandi Foreste come una tua Terra, in aggiunta a quella che scegli con *Nato dalla Terra*.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoNano: Move = {
  id: 'druido.archetipo-nano',
  name: 'Archetipo: Nano',
  type: 'class_special',
  classId: 'druido',
  trigger: 'Quando prendi *Fratello del Cacciatore* o *Sorella del Predatore*',
  description: 'Puoi scegliere anche tra le mosse dello Sciamano.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoHalfling: Move = {
  id: 'druido.archetipo-halfling',
  name: 'Archetipo: Halfling',
  type: 'class_special',
  classId: 'druido',
  trigger: 'Quando vi *accampate*',
  description:
    'Canti le canzoni risananti delle sorgenti e dei ruscelli. Al risveglio, tu e i tuoi alleati guarite +1d6 PF;',
  tags: [],
  prerequisites: [],
  replaces: [],
};

const archetipoMezzorco: Move = {
  id: 'druido.archetipo-mezzorco',
  name: "Archetipo: Mezz'orco",
  type: 'class_special',
  classId: 'druido',
  trigger:
    'Quando *parlamenti* con animali, spiriti della natura o esseri fatati, oppure *sfidi il pericolo* (con **CAR**) contro di essi',
  description: 'Hai +1 al tiro. Con gente civilizzata, invece, subisci -1.',
  tags: [],
  prerequisites: [],
  replaces: [],
};

export const druidoArchetypeMoves: readonly Move[] = [
  archetipoUmano,
  archetipoElfo,
  archetipoNano,
  archetipoHalfling,
  archetipoMezzorco,
] as const;
